import React, { useEffect, useState } from "react";
import fire from "../../config/fire";
import { useDispatch, useSelector } from "react-redux";
import { getPosts } from "../../redux/actionCreators/postsActionCreator";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { newPost } from "../../redux/actionCreators/postsActionCreator";
import { checkPosition } from "../../redux/actionCreators/postsActionCreator";
import { useHistory } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import TimePicker from "rc-time-picker";
import 'rc-time-picker/assets/index.css';
import moment from 'moment';
import "./placeholder.css";

const AddPost = () => {
  const userId = useSelector((state) => state.auth.userId);
  const user = useSelector((state) => state.auth.user);
  const dispatch = useDispatch();
  const history = useHistory()
  let check = false, posCheck = 0, now, end;
  let startT = "",endT = "",startD ="",endD ="";

  const [posttext, setPosttext] = useState("");
  const [location, setLocation] = useState("");
  const [description, setDescription] = useState("");
  const [image, setImage] = useState("");
  const [startdate, setStartdate] = useState(new Date());
  const [starttime, setStarttime] = useState("");
  const [enddate, setEnddate] = useState(new Date());
  const [endtime, setEndtime] = useState("");
  const [position, setPosition] = useState();
  const [progress, setProgress] = useState();
  const [disable, setDisable] = useState(false);
  // const [startDate, setStartDate] = useState(new Date());
  useEffect(() => {
    dispatch(getPosts());
  
    }, [dispatch]);
    const handleSubmit = (e) => {
    e.preventDefault();
    
    setProgress(100);

    startT = (moment(startdate).format("h:mm a"));
    startD = moment(startdate).format("MM-DD-YYYY");
    endT = moment(enddate).format("h:mm a");
    endD = moment(enddate).format("MM-DD-YYYY");

    if (!posttext || !location || !description || !position || !startdate || !enddate ) {
      setProgress(0);
      return toast.error("Please fill in all fields!");
    }

    if(startdate.valueOf() >= enddate.valueOf())
    {
      setProgress(0);
      return toast.error("End Date/Time must be greater than Start Date/Time")
    }

    if (description.length < 20) {
      setProgress(0);
      return alert("Description should be of atleast 20 words");
      // return toast.error("Description should be of atleast 20 words");
    }

    if (!image || image === undefined) {
      setProgress(0);
      return toast.warning("Please select an image!");
    }

    // if (title.trim().split(" ").length < 2) {
    //   return toast.info("Title should be of atleast 2 words");
    // }
    if (image.size > 5242880) {
      setProgress(0);
      return toast.error("Image should be less than or equal to 5 MB");
    }
    const allPosts = dispatch(checkPosition(position))
    .then(responses => {
      responses.forEach((response) => {
        if(posCheck < response.post.position)
        {
          posCheck = response.post.position;
        }  
        if(response.post.position == position)
        {
          now = (moment(new Date()).format('MM-DD-YYYY h:mm a'));
          end = (moment(new Date(`${response.post.endDate} ${response.post.endTime}`)).format('MM-DD-YYYY h:mm a'));
          console.log(now)
          console.log(end)
          if(now.valueOf() < end.valueOf())
          {
            check = true;
            setProgress(0);
            return toast.error("Position already exists");
          }
        }
        return;
      })
    if(((position%7) != 0) && (position!=1))
    {
      setProgress(0);
      return toast.error(`Position must be a multiple of 7`)
    }
    if(!check)
    {
      const data = {
        posttext,
        location,
        description,
        startD,
        startT,
        endD,
        endT,
        position,
        image,
      };
      check = false;
      dispatch(newPost(data, userId, user.displayName, setProgress, history));
      // { setTimeout(() => {
      //   history.push("/admin/dashboard/posts")
      //   },2000) 
      // }
    }
  })
    
    // if(all)
    // {
    //   console.log(all);
    //   return toast.info("Position checked");
    // }
    //dispatch(checkPosition(position));
    
  };
  

  // function refreshPage() {
  //   window.location.reload(false);
  //   history.push("/admin/dashboard/posts")
  // }

  return (
    <div className="container" style={{minHeight: "750px"}}>
      {progress == 100 ? (
            <div className="text-center mt-5 ml-4 mb-5">
              <h6 className="display-4 text-dark" style={{fontSize: "38px"}}>Please Wait...</h6>
            </div>
          ) : (
      <div className="row">
        {/* <div className="col-md-12 text-right">
          <Link to="/admin/dashboard" className="btn mr-2" style={{backgroundColor: "#1AC5D9", borderRadius: "100px", color: "white"}}>
            Go Back
          </Link>
        </div> */}
        <div className="col-md-12 mb-3">
        <Link to="/admin/dashboard" className="btn float-left" style={{backgroundColor: "#1AC5D9", borderRadius: "100px", color: "white", marginTop: "2.6rem"}}>
            Go Back
          </Link>
          <h6 className="display-4 text-dark text-center mr-5 px-4" style={{fontSize: "38px", marginTop: "2.4rem"}}>Create Ad</h6>
        </div>
        <div className="col-md-6 mx-auto mb-5 shadow p-5" style={{backgroundColor: "white"}}>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label><h6>Post Text</h6></label>
                <input
                  type="text"
                  placeholder="Post Text"
                  className="form-control"
                  value={posttext}
                  onChange={(e) => setPosttext(e.target.value)}
                />
              </div>
              <div className="form-group">
                <label style={{font: "SF Pro Text"}}><h6>Location</h6></label>
                <input
                  type="text"
                  placeholder="Location"
                  className="form-control"
                  value={location}
                  onChange={(e) => setLocation(e.target.value)}
                />
              </div>
              <div className="form-group">
                <label><h6>Start Date/Time</h6></label>
                <DatePicker 
                  selected={startdate} 
                  className="form-control"  
                  minDate={moment().toDate()}
                  timeInputLabel="Time:"
                  dateFormat="MM-dd-yyyy h:mm aa"
                  showTimeInput 
                  onChange={(date) => setStartdate(date)} 
                />
                {/* <input
                  type="string"
                  placeholder="Start Date"
                  className="form-control"
                  value={startdate}
                  onChange={(e) => setStartdate(e.target.value)}
                /> */}
              </div>
              {/* <div className="form-group">
                <label><h6>Start Time</h6></label>
                <TimePicker
                  selected={starttime}
                  placeholder="Select Time"
                  use12Hours
                  showSecond={false}
                  focusOnOpen={true}
                  format="hh:mm a"
                  onChange={e => setStarttime(e.format('LT'))}
                /> */}
                  {/* <input
                  type="text"
                  placeholder="Start Time"
                  className="form-control"
                  value={starttime}
                  onChange={(e) => setStarttime(e.target.value)}
                /> */}
              {/* </div> */}
              <div className="form-group">
                <label><h6>End Date/Time</h6></label>
                  <DatePicker 
                    selected={enddate} 
                    className="form-control" 
                    minDate={moment().toDate()}
                    timeInputLabel="Time:"
                    dateFormat="MM-dd-yyyy h:mm aa"
                    showTimeInput 
                    onChange={(date) => setEnddate(date)}
                  />
                {/* <input
                  type="text"
                  placeholder="End Date"
                  className="form-control"
                  value={enddate}
                  onChange={(e) => setEnddate(e.target.value)}
                /> */}
              </div>
              {/* <div className="form-group">
                <label><h6>End Time</h6></label>
                <input
                  type="text"
                  placeholder="End Time"
                  className="form-control"
                  value={endtime}
                  onChange={(e) => setEndtime(e.target.value)}
                />
              </div> */}
              <div className="form-group">
                <label><h6>Position</h6></label>
                <input
                  type="number"
                  placeholder="Position"
                  className="form-control"
                  value={position}
                  onChange={(e) => setPosition(e.target.value)}
                />
                <li className="ml-2 mt-1" style={{color:"#1AC5D9"}}>Enter position in multiples of 7 only</li>
              </div>
              <div className="form-group">
                <label><h6>Description</h6></label>
                <textarea
                  placeholder="Enter Description"
                  className="form-control"
                  rows="2"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                ></textarea>
              </div>
              <div className="form-group">
                <label><h6>Upload Image</h6></label>
                <input
                  type="file"
                  className="form-control" style={{paddingBottom: "35px"}}
                  onChange={(e) => setImage(e.target.files[0])}
                  accept="image/png, image/jpeg, image/jpg"
                />
              </div>
              <div className="form-group">
                <input
                  type="submit"
                  className="btn btn-block"
                  value="Submit" style={{backgroundColor: "#1AC5D9", borderRadius: "100px", color: "white", paddingTop: "0.5rem",paddingBottom: "0.5rem", paddingLeft: "1rem", paddingRight: "1rem"}}
                />
              </div>
            </form>
        </div>
      </div>
       )}
    </div>
  );
};

export default AddPost;
